module.exports = __webpack_public_path__ + "img/xiongmao.96664d71.gif";